<template>
    <div>
        <br>
        <br>
        <v-col cols="12">
            <v-img contain
                lazy-src="../assets/notFoundPedido.png"
                max-height="270"
                src="../assets/notFoundPedido.png"
            ></v-img>
        </v-col>

        <v-col cols="12" md="6" offset-md="3" lg="4" offset-lg="4">
        

        <h1 class="headline text-center font-weight-bold my-4 red--text text--darken-2 mt-0">El pedido no pudo ser encontrado</h1>

        <p class="text-left subtitle-2">
            <ul style="list-style: none;">
            <li>- Verifique que la información ingresada sea válida.</li>
            <li>- En caso de haber realizado su compra recientemente, favor de intentarlo mas tarde.</li>
            <li>- Revise su conexión de internet para validar que no existe intermitencia.</li>
            </ul>
            
        </p>
        <p class="text-center"><small><b>Nota</b> - el pedido puede tardar hasta 24hrs en reflejarse en el sistema</small></p>

        <a href="https://kuroda.com/" style="text-decoration: none;"><p class="text-center red--text text--darken-2"><small>volver a Kuroda</small></p></a>
        
        </v-col>
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>